import { Injectable } from '@angular/core';

import { HttpApiService } from '@core/http-legacy';
import { HttpApi } from '@core/http-types';

import { ReportsRequestData } from './reports-request-data.service';

@Injectable()
export class SharedAnalyticsReportsHttpApiService extends HttpApiService implements HttpApi {
  constructor() {
    const httpRequestData = new ReportsRequestData();
    super(httpRequestData);
  }
}
